import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const articles = [{
  category: 'Architecture Trends',
  title: 'The Return of Heavy Timber in Mountain Homes',
  excerpt: 'Exploring how massive Douglas fir beams are being reimagined in contemporary mountain architecture.',
  image: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?w=800&q=80'
}, {
  category: 'Material Selection',
  title: 'Raw Steel: Beauty in Industrial Honesty',
  excerpt: 'Understanding the warmth, durability, and character of weathered steel in residential design.',
  image: 'https://images.unsplash.com/photo-1600566752355-35792bedcfe1?w=800&q=80'
}, {
  category: 'Client Stories',
  title: 'Building the Schweitzer Ridge House',
  excerpt: 'A behind-the-scenes look at the engineering marvel that became our most awarded project of 2023.',
  image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&q=80'
}];
export function FieldNotes() {
  return <section className="relative py-24 bg-white" data-id="element-36">
      {/* Subtle basalt texture */}
      <div className="absolute inset-0 texture-basalt opacity-40" data-id="element-37" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <span className="text-[#A07656] uppercase tracking-widest text-sm font-semibold mb-2 block" data-id="element-40">
            Insights
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A]" data-id="element-41">
            Field Notes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-42">
          {articles.map((article, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-43">
              <div className="relative overflow-hidden aspect-[4/3] mb-6 bg-[#E8E4DF]" data-id="element-44">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-45" />
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/20 transition-colors duration-500" data-id="element-46" />
              </div>
              <div className="space-y-3" data-id="element-47">
                <span className="text-xs font-bold uppercase tracking-widest text-[#A07656]" data-id="element-48">
                  {article.category}
                </span>
                <h3 className="text-xl font-serif font-bold text-[#1A1A1A] group-hover:text-[#A07656] transition-colors" data-id="element-49">
                  {article.title}
                </h3>
                <p className="text-[#595959] text-sm leading-relaxed" data-id="element-50">
                  {article.excerpt}
                </p>
                <div className="pt-2 flex items-center gap-2 text-sm font-semibold text-[#1A1A1A] group-hover:gap-3 transition-all" data-id="element-51">
                  Read Article <ArrowRight className="w-4 h-4" data-id="element-52" />
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}